import {
  apply_markup_to_number,
  parse_fligth_offer_bags,
} from "@liveflight/utilities/flight-offer";
import { get_amenity_info } from "@liveflight/resources";

export { apply_markup_to_number, parse_fligth_offer_bags, get_amenity_info };

export const get_branded_fare = (flight_offer) => {
  try {
    return flight_offer.travelerPricings[0].fareDetailsBySegment[0].brandedFare;
  } catch {
    return undefined;
  }
};

export const show_amenity = (amenity) => !amenity.isChargeable;

export const get_selected_fare = (flight_offers_upsell, flight_offer_data) => {
  const default_branded_fare = get_branded_fare(flight_offer_data);
  for (let index = 0; index < flight_offers_upsell.length; index++) {
    const upsell = flight_offers_upsell[index];
    if (default_branded_fare === get_branded_fare(upsell)) {
      return upsell;
    }
  }
  return flight_offer_data;
};

export const get_fare_button_text = (
  item,
  selected_flight_offer_id,
  flight_offer_default,
) => {
  if (item.id === selected_flight_offer_id) {
    if (item.id === flight_offer_default.id) {
      return "Default";
    }
    return "Rimuovi";
  }
  return "Scegli";
};

export const is_amenity_present = (offers_amenities, offer_id, amenity_code) =>
  (offers_amenities[offer_id] || []).includes(amenity_code);

export const toggle_selected_class = (item, selected_flight_offer_id) =>
  item.id === selected_flight_offer_id ? "selected" : "";
